import { render, staticRenderFns } from "./Bingchuan.vue?vue&type=template&id=7476d846&scoped=true"
import script from "./Bingchuan.vue?vue&type=script&lang=ts"
export * from "./Bingchuan.vue?vue&type=script&lang=ts"
import style0 from "./Bingchuan.vue?vue&type=style&index=0&id=7476d846&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7476d846",
  null
  
)

export default component.exports